import {BigDecimal} from '@dms/api/shared';

export type PurchasePaymentCardPaymentRequestBody = {
  paymentDiscriminator: PurchasePaymentCardPaymentRequestBody.paymentDiscriminator;
  paymentMethod: PurchasePaymentCardPaymentRequestBody.paymentMethod;
  dueDate: string;
  cashRegisterId: string;
  createCashRegisterDocument: boolean | null;
  amount: BigDecimal;
  exchangeRate: string | null;
  supplierInvoiceNumber: string | null;
  dateOfTaxableSupply: string | null;
};

export namespace PurchasePaymentCardPaymentRequestBody {
  export enum paymentDiscriminator {
    PURCHASE = 'PURCHASE',
  }

  export enum paymentMethod {
    PAYMENT_CARD = 'PAYMENT_CARD',
  }
}
